import { useRolodexEntries } from 'features/rolodex'
import { RolodexEntryType } from 'types'

export function useCmmsExplorerSiteConfig(siteId: string | undefined) {
  const { siteConfigs, isLoading, hasEverLoaded, error } = useRolodexEntries(
    siteId
      ? {
          type: [RolodexEntryType.SITE_CONFIG],
          tags: { site: siteId },
          limit: 1,
        }
      : undefined
  )
  return {
    enabled: siteConfigs[0]?.data.enableCmmsExplorer === true,
    isLoading: Boolean(siteId) && (isLoading || !hasEverLoaded),
    error,
  }
}
